import { useGetNodeUsageAnalytics } from "./useGetNodeUsageAnalytics.ts";

export const useNodeVisitCounts = (nodeId: number) => {
  const getNodeVisitData = useGetNodeUsageAnalytics();
  return getNodeVisitData(nodeId)?.visitCounts;
};
